import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  standalone: false,
})
export class AuthComponent {
  @Input() isAtLeastMedium = true;
}
